<template>
  <el-card class="box-card">
    <div slot="header">
      <strong style="font-size: 14px">其他</strong>
    </div>
    <div style="width: 400px">
      <el-form-item label="备注(选填)">
        <el-input
          v-model="remarks"
          type="textarea"
          placeholder="请输入备注"
          :rows="3"
          class="formItemStyle"
          @change="changeRemarks"
          :disabled="disabled"
        ></el-input>
      </el-form-item>
    </div>
  </el-card>
</template>
<script>
export default {
  name: 'otherCard',
  props: {
    remarks: String,
    disabled: Boolean
  },
  methods: {
    changeRemarks() {
      this.$emit('update:remarks', this.remarks)
    }
  }
}
</script>
<style scoped>
.box-card {
  margin-bottom: 20px;
}
.formItemStyle {
  width: 100%;
}
</style>
